import cn from 'classnames'
import React from 'react'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'

import * as s from './PanelIconSettings.module.scss'

interface IPanelIconSettingsProps {
  active?: boolean
}

const PanelIconSettings: React.FC<IPanelIconSettingsProps> = ({ active }) => {
  return (
    <div className={cn(s.root, { [s.active]: active })}>
      <Icon name='energy' size={KitSize.S} />
    </div>
  )
}

export default React.memo(PanelIconSettings) as typeof PanelIconSettings
